import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../../../asset/images/home/Logo (1).png';

function Sidebar({ isOpen, toggleSidebar }) {
    const location = useLocation();

    return (
        <>
            {/* Overlay */}
            <div
                id="overlay"
                className={`${isOpen ? '' : 'hidden'} lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30`}
                onClick={toggleSidebar}
            />

            {/* Sidebar */}
            <aside
                id="sidebar"
                className={`fixed lg:static inset-y-0 left-0 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0 transition-transform duration-300 ease-in-out z-40`}
            >
                <div className="sidebar-inner">
                    {/* Logo Section */}
                    <div className="logo-section">
                        <div className="logo-card">
                            <img src={Logo} alt="READ 21 Logo" className="max-w-full max-h-full object-contain" />
                        </div>
                    </div>

                    {/* Navigation */}
                    <nav className="sidebar-nav" role="navigation" aria-label="Main navigation">
                        {/* Main Navigation Items (Vertically Centered) */}
                        <div className="nav-main">
                            {/* Dashboard */}
                            <Link
                                to="/dashboard"
                                className={`nav-item ${location.pathname === '/dashboard' ? 'active' : ''}`}
                                aria-current={location.pathname === '/dashboard' ? 'page' : undefined}
                                onClick={() => window.innerWidth < 1024 && toggleSidebar()}
                            >
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"/>
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 5a2 2 0 012-2h4a2 2 0 012 2v2H8V5z"/>
                                </svg>
                                Dashboard
                            </Link>

                            {/* Modules */}
                            <Link
                                to="/dashboard/modules"
                                className={`nav-item ${location.pathname === '/dashboard/modules' ? 'active' : ''}`}
                                onClick={() => window.innerWidth < 1024 && toggleSidebar()}
                            >
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
                                </svg>
                                Modules
                            </Link>

                            {/* Documents */}
                            <Link
                                to="/dashboard/documents"
                                className={`nav-item ${location.pathname === '/dashboard/documents' ? 'active' : ''}`}
                                onClick={() => window.innerWidth < 1024 && toggleSidebar()}
                            >
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                                </svg>
                                Documents
                            </Link>

                            {/* Settings */}
                            <Link
                                to="/dashboard/settings"
                                className={`nav-item ${location.pathname === '/dashboard/settings' ? 'active' : ''}`}
                                onClick={() => window.innerWidth < 1024 && toggleSidebar()}
                            >
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                                </svg>
                                Settings
                            </Link>
                        </div>

                        {/* Help Section (Fixed at Bottom) */}
                        <div className="nav-bottom">
                            <Link to="/help" className="nav-item">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                </svg>
                                Help
                            </Link>
                        </div>
                    </nav>
                </div>
            </aside>
        </>
    );
}

export default Sidebar;